import { CreateForm } from "./form.js";
import { getStripePublishableKey } from "./utils.js";

export class PaymentMethodForm {
  constructor(publishable_key) {
    this.stripe = Stripe(publishable_key);

    this.setupStripe();
    this.CreateForm();

    this.form = this.CreateForm();
    return this;
  }

  static async setupFormWithStripeKey() {
    const publishable_key = await getStripePublishableKey();
    return new PaymentMethodForm(publishable_key);
  }

  setupStripe() {
    const elements = this.stripe.elements();

    const style = {
      base: {
        fontSize: "14px",
        "::placeholder": { color: "#aab7c4" },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    this.card = elements.create("card", { style, hidePostalCode: true });

    this.card.on("change", (event) => {
      const cardErrors = document.getElementById("card-errors");
      cardErrors.textContent = event.error ? event.error.message : "";
    });
  }

  CreateForm() {
    let form = new CreateForm("payment-form", [
      [
        12,
        [
          {
            type: "stripe",
            id: "card-element",
            label: "Card Details",
            card: this.card,
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "text",
            id: "nameOnCard",
            label: "Name on Card",
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "select",
            id: "cardCountry",
            label: "Country",
            preDefinedSelect: "country",
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "textarea",
            id: "cardAddress",
            label: "Address",
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "text",
            id: "cardCity",
            label: "City",
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "state",
            id: "cardState",
            label: "State",
            required: true,
          },
        ],
      ],
      [
        12,
        [
          {
            type: "text",
            id: "cardPostalCode",
            label: "Postal Code / ZIP",
            required: true,
          },
        ],
      ],
    ]).form;

    return form;
  }
}
